
import {
    ApiCall
} from './index';

export const RISKS = "/risks";

export const create = async(data) => {
    return await ApiCall('POST', RISKS, JSON.stringify(data), true, true);
};

export const getRisks = async(data) => {
    let query = `mine_id=${data.mine_id}&page=${data.page}&size=5`;
    if(data.template_id)
        query += `&type=${data.template_id}`;

    return await ApiCall('GET', `${RISKS}?${query}`);
};



// WEBPACK FOOTER //
// ./src/services/risk.js